export default "__VITE_ASSET__CoZcaOtm__"